// ** React Imports
import { Outlet, Navigate } from 'react-router-dom'
import { Suspense } from 'react'

// ** Component Imports
import { Breadcrumbs, FallbackLoader } from '@/shared/ui'

// ** Styled Components
import {
	LayoutWrapper,
	LayoutPageContent,
	LayoutContentWrapper
} from './styles'
import { Sidebar } from '@/widgets/Sidebar'

// ** Entity Imports
import { useGetCurrentUserQuery } from '@/entities/user'

export const LayoutWithSidebar = () => {
	const { data: currentUser, isLoading } = useGetCurrentUserQuery()

	// prevent the user from accessing the dashboard if they don't have an active subscription
	if (!currentUser?.activeSubscription && !isLoading) {
		return <Navigate to='/choose-plan' replace />
	}

	return (
		<LayoutWrapper>
			<Sidebar />
			<LayoutContentWrapper>
				<LayoutPageContent>
					<Breadcrumbs />
					<Suspense fallback={<FallbackLoader />}>
						<Outlet />
					</Suspense>
				</LayoutPageContent>
			</LayoutContentWrapper>
		</LayoutWrapper>
	)
}
